import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import FaqListView from "~faq/components/faq-list-view"
import {Typography} from '@mui/material'

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class FaqList extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {
    const { classes}: {classes: ClassNameMap} = this.props
    const { status} = this.state

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else {
      view = <FaqListView></FaqListView> 
    }

    return (
      <AppView>
        <Require classes={{}} > {/* requireOneOfFeatures={["fa"]}> */}
            <Typography id="faqTitle" variant="h5" className={classes.heading}>
               Frequently Asked Questions
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(FaqList)
